export default function currencyFilter(value, toDollars, trimPadding) {
	if (isFinite(value)) {

		let decimals = 2;
		// convert to dollars from cents
		if (toDollars) {
			value = +(value / 100).toPrecision(15);
		}
		// remove decimals for display
		if (trimPadding) {
			decimals = 0;
		}
		// insert commas for display
		return '$' + value.toFixed(decimals).replace(/(\d)(?=(\d{3})+\.\d\d$)/g,"$1,");
	} else {
		return value;
	}
}



// WEBPACK FOOTER //
// ./src/filters/currency.js